<div class="intereses-page" *ngIf="!loadingPage">
    <div class="d-flex align-items-center title-purchases mobile" *ngIf="isMobile">
        <span (click)="goBack()"><i class="icon-back fa-light fa-arrow-left"></i></span>
        <p class="name-profile m-0">Atrás</p>
    </div>
    <!-- <div class="page-wrapper">
        <p class="mb-2 text-center container title-intereses">Mis intereses</p>
    </div> -->

    <div class="align-items-center title-purchases mobile" (click)="goBack()">
        <span><i class="icon-back fa-light fa-arrow-left"></i></span>
        <p class="name-profile m-0">Atrás</p>
    </div>

    <div class="container-intereses container">
        <div *ngFor="let cat of categorias" class="cat-pref"
            [class.active]="categoriasSelected.includes(cat['@id'])" (click)="selectCategory(cat)">
            <i class="fa-thin {{ cat.icon }} icon-primary"></i>
            <p class="m-0">{{cat.nombre}}</p>
        </div>
    </div>
    <div class="d-flex justify-content-center cont-button">
        <button class="primary-button solid" (click)=savePreferences()>Guardar cambios</button>
    </div>
</div>
<div class="loading-container" *ngIf="loadingPage">
    <ng-lottie class="lottie" [options]="loadingLottie" containerClass="loading-box"></ng-lottie>
</div>